import { render, staticRenderFns } from "./index.vue?vue&type=template&id=d542a49a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=d542a49a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d542a49a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\wangchen\\1666-syltcsq\\j1666_syltcsq_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d542a49a')) {
      api.createRecord('d542a49a', component.options)
    } else {
      api.reload('d542a49a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=d542a49a&scoped=true", function () {
      api.rerender('d542a49a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/productCouponList/form/index.vue"
export default component.exports